export const createPerformanceFilterTransform =
  (engagementType) =>
  (filterData = {}) => {
    const fallbackEngagementType = engagementType ? [engagementType] : [];

    return {
      ...filterData,
      engagementStatus: Array.isArray(filterData.engagementStatus)
        ? filterData.engagementStatus
        : [],
      engagementType: Array.isArray(filterData.engagementType)
        ? filterData.engagementType
        : fallbackEngagementType,
    };
  };
